module.exports = __webpack_public_path__ + "img/bronze.10b12396.png";